import { render, staticRenderFns } from "./section2.vue?vue&type=template&id=79c4bbc2&scoped=true"
import script from "./section2.vue?vue&type=script&lang=js"
export * from "./section2.vue?vue&type=script&lang=js"
import style0 from "./section2.vue?vue&type=style&index=0&id=79c4bbc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c4bbc2",
  null
  
)

export default component.exports